// Сетка зон задания (ADR-008): декодирование RLE и прямоугольники для подсветки.
import type { ZoneGrid } from "@brovka/content-types";

/** Раскодировать сетку: серии байтов (значение << 6) | (длина − 1), base64. */
export function decodeGrid(z: ZoneGrid): Uint8Array {
  const bin = atob(z.rle);
  const out = new Uint8Array(z.cols * z.rows);
  let i = 0;
  for (let k = 0; k < bin.length; k++) {
    const b = bin.charCodeAt(k);
    const v = b >> 6;
    const n = (b & 0x3f) + 1;
    out.fill(v, i, Math.min(out.length, i + n));
    i += n;
  }
  if (i !== out.length) throw new Error(`сетка: ${i} ячеек вместо ${out.length}`);
  return out;
}

export type ZoneRect = { x: number; y: number; w: number; h: number; v: number };

/** Слить соседние ячейки одной оценки в прямоугольники (в метрах). */
export function zoneRects(cells: ArrayLike<number>, cols: number, rows: number, cellM: number, keep: (v: number) => boolean): ZoneRect[] {
  const out: ZoneRect[] = [];
  for (let r = 0; r < rows; r++) {
    let c = 0;
    while (c < cols) {
      const v = cells[r * cols + c]!;
      let n = 1;
      while (c + n < cols && cells[r * cols + c + n] === v) n++;
      if (keep(v)) out.push({ x: c * cellM, y: r * cellM, w: n * cellM, h: cellM, v });
      c += n;
    }
  }
  return out;
}
